import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // Considera usar variables de entorno para estas URLs y tokens según el ambiente (desarrollo, producción)
    baseUrl: 'https://py.loginsa.com/api_oms/api/tracking/', //<----- PRODUCCIÓN
    baseUrlCourier: "https://ws.loginsa.com/ApiPortalInfor/api/", // <- PRODUCCION-IMAGE
    // baseUrlCourier: "https://localhost:44373/api/", //<-- DEPURACION-IMAGE
    // baseUrlCourier: "https://tzl.loginsa.com/ApiPortalInfor/api/", //<- TEST-IMAGE
    // baseUrl: 'http://10.15.3.174/api_oms/api/tracking', //<----- TESTING
    // token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbXByZXNhIjoiTG9naW5zYSIsImVtYWlsIjoidHJhY2tpbmdAbG9naW5zYS5jb20iLCJjZW50cm9zIjpbIndod21zZTUiXSwiY2xpZW50ZXMiOlsiTDAwMzU3Il0sInBlcmZpbCI6IjAwMSIsImlkIjoiMWI2ZjUwMWQtMDEzMi00YzU3LWFmNzYtZmJlNDI5NDI1OTJlIiwiZXhwIjoxNzY5OTYzMzU1LCJpYXQiOjE2ODM1NjMzNTV9.FLDYUOPPlS1BsAgQWwhYjKeiOHVHz-lmj4hEcNtWRv8',
    token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjNmZGIyZThlLTE4MzAtNGY5Zi1hY2E0LTYyMThmYTBhMmJiMCIsImV4cCI6MTg2Njk3MDk1NCwiaWF0IjoxNzgwNTcwOTU0fQ.xPWRfyX5f0hHJFIYCWV5kMTqLtAi1Mpnwv2BkPsnF_o',
    tokenCourier: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImpidXN0b3MiLCJuYmYiOjE3MjA1NTc2ODcsImV4cCI6MTcyMDU2NDg4NywiaWF0IjoxNzIwNTU3Njg3LCJpc3MiOiJodHRwOi8vbG9jYWxob3N0OjgwODIiLCJhdWQiOiJodHRwOi8vbG9jYWxob3N0OjgwODIifQ.SLcbKJlIudRDVJ8JKAdJYE2frMV6yiwOABfgPckdSh8',
    idTrack: null,
    ordenClienteFinal: null,
    storerKey: null,
    // Inicializamos loading como un objeto para evitar errores al acceder a sus propiedades
    loading: {
      titulo: '',
      estado: false,
      color: ''
    },
    theme: null,
    hideItem: false,
    couriers: [],
    mobile: false,
    logo2: null,
    buscador: true,
    selectedCourier: null,
    // Inicializamos imagen como array y otras propiedades que se utilizan en mutaciones
    imagen: [],
    cuenta: null,
    url: null,
  },
  getters: {
    mapImagen(state) {
      return state.imagen.map(img => ({
        text: img.nombre.toUpperCase(),
        value: img.id_cliente,
        img: img.logo2,
      }));
    },
    mapCouriers(state) {
      return state.couriers.map(cli => ({
        id: cli.id,
        nombre: cli.nombre,
        id_cliente: cli.id_cliente,
        estado: cli.estado,
        logo: cli.logo,
        logo2: cli.logo2
      }));
    },
    selectedCourier(state) {
      return state.selectedCourier; // Getter para obtener el courier seleccionado
    },
  },
  mutations: {
    setSelectedCourier(state, courier) { // Establece el courier seleccionado
      state.selectedCourier = courier;
    },
    setIdTrack(state, payload) {
      state.idTrack = payload;
    },
    setOrdenClienteFinal(state, payload) {
      state.ordenClienteFinal = payload;
    },
    setCouriers(state, couriers) {
      state.couriers = couriers;
    },
    setStorerKey(state, payload) {
      state.storerKey = payload;
    },
    mostrarLoading(state, payload) {
      state.loading.titulo = payload.titulo;
      state.loading.estado = true;
      state.loading.color = payload.color;
    },
    ocultarLoading(state) {
      state.loading.estado = false;
    },
    setTheme(state, payload) {
      state.theme = payload;
    },
    setHide(state, payload) {
      state.hideItem = payload;
    },
    setMobile(state, payload) {
      state.mobile = payload;
    },
    setImagen(state, payload) {
      state.imagen = payload;
    },
    setCuenta(state, payload) {
      state.cuenta = payload;
    },
    setUrl(state, payload) {
      state.url = payload;
    },
    setBuscador(state, payload) {
      state.buscador = payload;
    },
  },
  actions: {
    listarCouriers({ state, commit }) {
      const url = `${state.baseUrlCourier}tracking/ListarCourier?token=${state.tokenCourier}`;
      axios.get(url)
        .then(response => {
          console.log('Request URL:', url);
          // Guarda la respuesta en el state a través de la mutación
          commit('setCouriers', response.data);
          console.log('DATA:', response.data);
        })
        .catch(error => {
          console.error('Error al obtener los couriers:', error);
        });
    }
  }
});
